import React, {useEffect, useState} from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import Skeleton from '@mui/material/Skeleton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Avatar from '@mui/material/Avatar';
import Slide from '@mui/material/Slide';

import {guestbook, StringAvatar} from './Functions.js';
import ButtonAction from './ButtonAction.js';

const UserInfo=(props)=>{

	const {item}=props;

	if(item.id===0){
		return (
			<>
				<Skeleton
					variant="circular"
					width={80}
					height={80}
					sx={{
						margin:'auto', 
					}}
					/>
				<Skeleton
					variant="string"
					width={120}
					sx={{
						fontSize:'.9rem', 
						margin:'15px auto 0'
					}}
					/>
			</>
		);
	}

	return (
		<>
			<div className="avatar">
				<Avatar
					{...StringAvatar(item.name)} // 已包含 sx，不能再加新的 sx
					/>
			</div>
			<p>{item.name}</p>
		</>
	);
}

const DateTime=(props)=>{

	const {item, label}=props;

	let block;

	if(item.id===0){
		block=(
			<Skeleton
				variant="string"
				width={120}
				sx={{
					fontSize:'.8rem', 
				}}
				/>
		);
	}else{
		block=item['date-time'];
	}

	return (
		<div className={'info '+label+'-info'}>
			{block}
		</div>
	);

}

const PostContent=(props)=>{

	const {label, item}=props;

	if(item.id===0){
		return (
			<DialogContent>
				<div className={'content '+label+'-content'}>
					<Skeleton
						width="100%"
						height="24px"
						sx={{
							marginBottom:'10px'
						}}
						variant="string"
						/>
					<Skeleton
						width="60%"
						height="24px"
						variant="string"
						/>
				</div>
			</DialogContent>
		);
	}else{
		return (
			<DialogContent>
				<div
					className={'content '+label+'-content'}
					dangerouslySetInnerHTML={{__html:item.post}}
					/>
			</DialogContent>
		);
	}
}

const ReplyBlock=(props)=>{

	const {item, SetPosts}=props;

	if(typeof item.reply==='undefined'||item.reply.length===0)return false;

	return (
		<>
			<div className="has-reply"></div>
			{
				item.reply.map((_item)=>(
					<div
						className="reply-list"
						key={'list-'+_item.id}
						>
						<Section
							item={_item}
							type="reply"
							data-parent={item.id}
							SetPosts={SetPosts}
							/>
					</div>
				))
			}
		</>
	);
}

const Transition=React.forwardRef(function Transition(props, ref){
	return (
		<Slide direction="down" ref={ref} {...props} />
	);
});

export const PopupPostBlock=(props)=>{

	const {SetOpen, SetPostID, intPostID, open}=props;

  const HandleClose=()=>{
    SetOpen(false);
  };

	return (
		<Dialog
			open={open}
			TransitionComponent={Transition}
			TransitionProps={{
				onTransitionEnd:(e)=>{
					if(e.propertyName!=='transform')return;
					if(e.target.nextElementSibling.getAttribute('tabindex')==='-1'){
						SetPostID(0);
						guestbook['post-id']=0;
					}else{
						SetPostID(guestbook['post-id']);
					}
				}
			}}
			keepMounted
			onClose={HandleClose}
			aria-describedby="alert-dialog-slide-description"
			maxWidth="md"
			fullWidth={true}
      >
			<DialogTitle sx={{textAlign:'center'}}>{intPostID==='new'?'New Post':'Reply'}</DialogTitle>
			<DialogContent
				sx={{overflow:'visible'}}
				>
				<TextArea
					pid={intPostID}
					{...props}
					/>
			</DialogContent>
		</Dialog>
	);

}

const TextArea=(props)=>{

	const {intPostID}=props;

	const [inputs, CheckInput]=useState([false, false]); // while `input` equals false, `input.length` would be undefined.
	const [processing, SendingPost]=useState(false);

	const HandleInput=e=>{
		if(e.target.id==='outlined-textarea'){
			CheckInput((value)=>{
				let NewValue=[value[0], e.target.value];
				return NewValue;
			});
			guestbook['new-post'].input=e.target.value;
		}else{
			guestbook['new-post'].name=e.target.value;
			CheckInput((value)=>{
				let NewValue=[e.target.value, value[1]];
				return NewValue;
			});
		}
	}

	const action=intPostID==='new'?'post':'reply';

	useEffect(()=>{
		
	}, [inputs]);

	return (
		<Box
      component="form"
      sx={{
        '& .MuiFormControl-fullWidth':{}, // element under Box ( form ) and class named `MuiTextField-root`
      }}
			justifyContent="center"
      noValidate
      autoComplete="off"
    	>
			<TextField
				required
				id="guest-name"
				label="Guest name"
				sx={{marginBottom:'20px'}}
				onChange={HandleInput}
				/>
			<TextField
				id="outlined-textarea"
				placeholder="Leave your message here..." 
				multiline
				label="Say something"
				rows={8}
				fullWidth={true}
				error={inputs[1].length===0}
				helperText={inputs[1].length===0?'Incorrect entry.':''}
				disabled={processing===true}
				onChange={HandleInput}
				/>
			<DialogActions
				sx={{padding:'15px 0 0'}}
				>
				<Stack
					spacing={1}
					direction="row"
					justifyContent="center"
					>
					<ButtonAction
						action={'submit-'+action}
						SendingPost={SendingPost}
						{...props}
						/>
				</Stack>
			</DialogActions>
		</Box>
	);
}

const ReplyButton=(props)=>{
	const {item, action, SetOpen, SetPostID}=props;
	if(action==='reply')return false;
	return (
		<ButtonAction
			action="reply"
			data-id={item.id}
			SetOpen={SetOpen}
			SetPostID={SetPostID}
			>
			Reply
		</ButtonAction>
	);
}

export const Section=(props)=>{

	const {item, type, SetOpen, SetPostID}=props;

	return (
		<section
			id={type+'-'+item.id}
			className={type+'-field'}
			>
			<div className="flex-left">
				<UserInfo item={item} />
			</div>
			<div className="flex-right">
				<DateTime
					item={item}
					label={type}
					/>

				<PostContent
					label={type}
					item={item}
					/>

				{
					(item.id>0&&(type==='post'||guestbook.permission.delete))
					&&
					<>
						<div className="action-field">
							<Stack spacing={1} direction="row" justifyContent="end">
								<ReplyButton
									item={item}
									data-id={item.id}
									action={type}
									{...{SetOpen, SetPostID}}
									/>
								{
									guestbook.permission.delete
									&&
									<ButtonAction
										action="delete"
										data-id={item.id}
										{...props}
										>
										Delete
									</ButtonAction>
								}
							</Stack>
						</div>
						<ReplyBlock
							{...props}
							/>
					</>
				}
			</div>
		</section>
	);
}

export const LoadMoreBlock=({SetPage, intLoading})=>{
	return (
		<div id="load-more">
			<ButtonAction
				action="load-more"
				{...{SetPage, intLoading}}
				>
				Load more
			</ButtonAction>
		</div>
	);
}

export const NewPostBlock=((props)=>{
	return (
		<div id="new-post">
			<ButtonAction
				action="new-post"
				{...props}
				>
				New post
			</ButtonAction>
		</div>
	);
});